
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import StaffList from "./employee-management/StaffList";
import RolesPermissions from "./employee-management/RolesPermissions";
import Attendance from "./employee-management/Attendance";
import PerformanceKPI from "./employee-management/PerformanceKPI";

const EmployeeManagement = () => {
  return (
    <div className="space-y-4">
      <h1 className="text-3xl font-bold">Employee Management</h1>
      <p className="text-muted-foreground">
        Manage employee records, roles, permissions, attendance and performance metrics.
      </p>
      
      <Tabs defaultValue="staff-list" className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="staff-list">Staff List</TabsTrigger>
          <TabsTrigger value="roles-permissions">Roles & Permissions</TabsTrigger>
          <TabsTrigger value="attendance">Attendance</TabsTrigger>
          <TabsTrigger value="performance-kpi">Performance & KPI</TabsTrigger>
        </TabsList>
        
        <TabsContent value="staff-list">
          <StaffList />
        </TabsContent>
        
        <TabsContent value="roles-permissions">
          <RolesPermissions />
        </TabsContent>
        
        <TabsContent value="attendance">
          <Attendance />
        </TabsContent>
        
        <TabsContent value="performance-kpi">
          <PerformanceKPI />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default EmployeeManagement;
